export const SET_SNACKBAR = "SET_SNACKBAR"
export const SET_SECOUND = "SET_SECOUND"
export const SET_OPEN_DRAWER = "SET_OPEN_DRAWER"
export const OPEN_COUNTER_MODAL = "OPEN_COUNTER_MODAL"
export const SET_ACTIVE_HEADER_MENU = "SET_ACTIVE_HEADER_MENU"
export const SET_USER_INFO = "SET_USER_INFO"
export const SET_IS_UPLOADER_EMAIL = "SET_IS_UPLOADER_EMAIL"








